/**
 * Motion tokeny — jednotné časování animací napříč webem.
 * Hodnoty odpovídají CSS tokenům (@theme: --ease-standard).
 */
import type { Transition } from "motion/react";

export const duration = {
  fast: 0.18,
  normal: 0.4,
  slow: 0.7,
} as const;

export const ease: {
  standard: [number, number, number, number];
  emphasized: [number, number, number, number];
} = {
  standard: [0.22, 1, 0.36, 1],
  emphasized: [0.16, 1, 0.3, 1],
};

export const spring: { soft: Transition } = {
  soft: { type: "spring", stiffness: 220, damping: 26, mass: 0.9 },
};

export type MotionDuration = typeof duration;
